import { useEffect, useState } from "react";
import { APPS } from "./constraints";

export const getApp = () => {
  const subdomain = getSubdomainApp(window.location.hostname);

  console.log("current subdomain is:", subdomain);

  const main = APPS.find((app) => app.main);
  if (!main) throw new Error("must have an App");

  if (subdomain === "") return main.app;

  const app = APPS.find((app) => subdomain === app.subdomain);
  if (!app) return main.app;

  return app.app;
};

export const getSubdomainApp = (location: string) => {
  const locationParts = location.split(".");
  let sliceTill = -2;
  const isLocalhost = locationParts.slice(-1)[0] === "localhost";

  if (isLocalhost) sliceTill = -1;

  let subdomain = locationParts.slice(0, sliceTill).join("");

  if (process.env.REACT_APP_STAGE === "qa") {
    if (!subdomain.includes("-qa")) {
      throw new Error("Incorrect Subdomain");
    }
  } else {
    if (subdomain.includes("-qa")) {
      throw new Error("-qa Is valid only for test environment");
    }
  }

  return subdomain;
};


 export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState('');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) setBreakpoint('xs');
      else if (width < 768) setBreakpoint('sm');
      else if (width < 1024) setBreakpoint('md');
      else if (width < 1280) setBreakpoint('lg');
      else setBreakpoint('xl');
    };

    handleResize(); 
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return breakpoint;
};

